!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("easyScroll", [], t) : "object" == typeof exports ? exports.easyScroll = t() : e.easyScroll = t();
}(this, function () {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "/", t(t.s = 0);
  }([function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = n(1),
        i = r(o),
        u = n(2),
        l = r(u),
        a = function a(e) {
      var t = e.easingPreset,
          n = e.cubicBezierPoints,
          r = e.duration,
          o = e.runTime,
          u = o / r;
      return i.default.hasOwnProperty(t) ? i.default[t](u) : n && !isNaN(n.x1) && !isNaN(n.y1) && !isNaN(n.x2) && !isNaN(n.y2) && n.x1 >= 0 && n.x2 >= 0 ? (0, l.default)({
        percentTimeElapsed: u,
        x1: n.x1,
        x2: n.x2,
        y1: n.y1,
        y2: n.y2
      }) : (console.error("Please enter a valid easing value"), !1);
    },
        c = function c(e) {
      var t = e.isWindow,
          n = e.scrollableDomEle,
          r = e.elementLengthProp,
          o = e.initialScrollPosition,
          i = e.isHorizontalDirection,
          u = e.scrollLengthProp,
          l = e.direction,
          a = void 0;

      if (t) {
        var c = document.documentElement;
        a = i ? c.offsetWidth : c.offsetHeight;
      } else a = n[u] - n[r];

      return ["left", "top"].includes(l) ? o : a - o;
    },
        s = function s(e) {
      var t = e.scrollableDomEle,
          n = e.onAnimationCompleteCallback,
          r = e.direction,
          o = e.onRefUpdateCallback,
          i = e.duration,
          u = e.cubicBezierPoints,
          l = e.easingPreset,
          s = e.scrollAmount,
          f = null,
          d = null,
          p = null,
          m = null,
          x = t === window,
          b = ["left", "right"].indexOf(r) > -1,
          y = ["right", "bottom"].indexOf(r) > -1;
      b ? (d = x ? "scrollX" : "scrollLeft", m = x ? "innerWidth" : "clientWidth", p = "scrollWidth") : (d = x ? "scrollY" : "scrollTop", m = x ? "innerHeight" : "clientHeight", p = "scrollHeight");
      var v = t[d],
          h = c({
        isWindow: x,
        scrollableDomEle: t,
        elementLengthProp: m,
        initialScrollPosition: v,
        isHorizontalDirection: b,
        scrollLengthProp: p,
        direction: r
      });
      !isNaN(s) && s < h && (h = s);

      var P = function e(r) {
        var c = r - f,
            s = a({
          easingPreset: l,
          cubicBezierPoints: u,
          runTime: c,
          duration: i
        });

        if (!isNaN(s)) {
          var p = s * h,
              m = y ? p + v : h - p;

          if (c < i) {
            if (x) {
              var P = b ? m : 0,
                  O = b ? 0 : m;
              window.scrollTo(P, O);
            } else t[d] = m;

            o ? o(requestAnimationFrame(e)) : requestAnimationFrame(e);
          } else n && n();
        }
      };

      requestAnimationFrame(function (e) {
        f = e, P(e);
      });
    };

    t.default = s, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = {
      linear: function linear(e) {
        return e;
      },
      easeInQuad: function easeInQuad(e) {
        return e * e;
      },
      easeOutQuad: function easeOutQuad(e) {
        return e * (2 - e);
      },
      easeInOutQuad: function easeInOutQuad(e) {
        return e < .5 ? 2 * e * e : (4 - 2 * e) * e - 1;
      },
      easeInCubic: function easeInCubic(e) {
        return e * e * e;
      },
      easeOutCubic: function easeOutCubic(e) {
        return --e * e * e + 1;
      },
      easeInOutCubic: function easeInOutCubic(e) {
        return e < .5 ? 4 * e * e * e : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1;
      },
      easeInQuart: function easeInQuart(e) {
        return e * e * e * e;
      },
      easeOutQuart: function easeOutQuart(e) {
        return 1 - --e * e * e * e;
      },
      easeInOutQuart: function easeInOutQuart(e) {
        return e < .5 ? 8 * e * e * e * e : 1 - 8 * --e * e * e * e;
      },
      easeInQuint: function easeInQuint(e) {
        return e * e * e * e * e;
      },
      easeOutQuint: function easeOutQuint(e) {
        return 1 + --e * e * e * e * e;
      },
      easeInOutQuint: function easeInOutQuint(e) {
        return e < .5 ? 16 * e * e * e * e * e : 1 + 16 * --e * e * e * e * e;
      }
    }, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function r(e) {
      return Math.pow(e, 3);
    },
        o = function o(e) {
      return 3 * e * e * (1 - e);
    },
        i = function i(e) {
      return 3 * e * Math.pow(1 - e, 2);
    },
        u = function u(e) {
      return Math.pow(1 - e, 3);
    },
        l = function l(e) {
      var t = e.percentTimeElapsed,
          n = e.x1,
          l = e.y1,
          a = e.x2,
          c = e.y2;
      return 1 - (n * r(t) + l * o(t) + a * i(t) + c * u(t));
    };

    t.default = l, e.exports = t.default;
  }]);
});